import React from "react";
import AllReports from "../../../components/allReports";

const ODADRSStatusUpdate = () => {
  const embeddedId = "eefa667c-240c-4680-b2e4-565a49880567";
  const rsl = [];
  const title = "ODA - DRS Status Update Adoption";

  return (
    <div style={{ padding: "16px" }}>
      <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
    </div>
  );
};

export default ODADRSStatusUpdate;
